// extracted by mini-css-extract-plugin
export default {"page":"styles_page__6Alfl","error":"styles_error__5I+uE","code":"styles_code__O+or9","message":"styles_message__8kDp9","image":"styles_image__EI3nm"};